import axios from 'axios';

const STATUS_API = '/api/get_following_status.php?company_id=';

/**
 * 企業をフォローしているかどうか返却
 * @param {number} companyId 企業ID
 */
export function fetchFollowStatus (companyId) {
  return axios(`${STATUS_API}${companyId}`).then(res => {
    if (res.data) {
      return true;
    } else {
      return false;
    }
  }).catch(() => {
    return false;
  });
}
